module.exports = __webpack_public_path__ + "img/burger.8636e16b.svg";